import React from 'react'
import createIcon from '@/lib/create-icon'

export const RefreshSVGIcon = createIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3744 3.25736V6.81385M14.3744 6.81385H10.818M14.3744 6.81385L11.6241 4.22947C10.987 3.59209 10.1989 3.12649 9.33324 2.87609C8.46757 2.62569 7.55257 2.59867 6.67363 2.79754C5.79469 2.99641 4.98045 3.4147 4.30689 4.01336C3.63333 4.61203 3.12241 5.37157 2.82178 6.2211M1.33398 12.7413V9.18485M1.33398 9.18485H4.89047M1.33398 9.18485L4.08434 11.7692C4.72139 12.4066 5.50953 12.8722 6.3752 13.1226C7.24087 13.373 8.15586 13.4 9.0348 13.2012C9.91374 13.0023 10.728 12.584 11.4015 11.9853C12.0751 11.3867 12.586 10.6271 12.8867 9.77759"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
)
